import axios from "axios";

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/email`;

// Custom Folders & Smart Email Routing (phase 1 plan 1). Mirrors the
// existing emailService.js pattern: getToken() + Bearer header per request,
// no shared axios instance interceptor dependency.

export const getCustomDestinationsService = async (getToken, { mailIntegrationId }) => {
  try {
    const token = await getToken();
    const response = await axios.get(
      `${API_BASE_URL}/destinations`,
      {
        params: { mailIntegrationId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching custom destinations:", error);
    throw error;
  }
};

export const getDestinationOptionsService = async (getToken, { mailIntegrationId }) => {
  try {
    const token = await getToken();
    const response = await axios.get(
      `${API_BASE_URL}/destination-options`,
      {
        params: { mailIntegrationId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching destination options:", error);
    throw error;
  }
};

// Plan 02: mode 'link' (resourceId) or mode 'create' (name). Defaults to
// 'link' for backward compatibility with callers that predate the mode
// parameter. Never sends both resourceId and name in the same request.
export const saveCustomDestinationService = async (getToken, {
  mailIntegrationId, mode = 'link', resourceId, name, routingInstructions,
}) => {
  try {
    const token = await getToken();
    const payload = mode === 'create'
      ? { mailIntegrationId, mode: 'create', name, routingInstructions }
      : { mailIntegrationId, mode: 'link', resourceId, routingInstructions };
    const response = await axios.post(
      `${API_BASE_URL}/destinations`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error saving custom destination:", error);
    throw error;
  }
};

export const enhanceRoutingInstructionsService = async (getToken, { routingInstructions }) => {
  try {
    const token = await getToken();
    const response = await axios.post(
      `${API_BASE_URL}/enhance-routing-instructions`,
      { routingInstructions },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error enhancing routing instructions:", error);
    throw error;
  }
};

// Plan 03 (Remove + Preferences): D-05 soft-disable. The mailbox folder is
// never deleted -- this only asks Geoffrey to stop managing it.
export const removeCustomDestinationService = async (getToken, { mailIntegrationId, destinationKey }) => {
  try {
    const token = await getToken();
    const response = await axios.delete(
      `${API_BASE_URL}/destinations/${encodeURIComponent(destinationKey)}`,
      {
        params: { mailIntegrationId },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error removing custom destination:", error);
    throw error;
  }
};
